import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface PresenceState {
  workspaceId: string;
  userId: string;
  status: 'online' | 'offline';
  pageId?: string | null;
  selectedNodeId?: string | null;
}
export interface LockState {
  resourceKey: string;
  userId: string | null;
  acquired: boolean;
}

export const useCollaborationStore = defineStore('collaboration', () => {
  const connected = ref(false);
  const presence = ref<Record<string, PresenceState>>({});
  const locks = ref<Record<string, LockState>>({});
  function setConnected(value: boolean): void {
    connected.value = value;
  }
  function updatePresence(value: PresenceState): void {
    const key = `${value.workspaceId}:${value.userId}`;
    if (value.status === 'offline') delete presence.value[key];
    else presence.value[key] = value;
  }
  function updateLock(value: LockState): void {
    if (value.acquired) locks.value[value.resourceKey] = value;
    else delete locks.value[value.resourceKey];
  }
  function applySnapshot(value: {
    workspaceId: string;
    presence: Array<Omit<PresenceState, 'workspaceId' | 'status'> & { updatedAt: string }>;
    locks: Array<{ resourceKey: string; userId: string }>;
  }): void {
    for (const [key, item] of Object.entries(presence.value))
      if (item.workspaceId === value.workspaceId) delete presence.value[key];
    for (const item of value.presence)
      presence.value[`${value.workspaceId}:${item.userId}`] = { ...item, workspaceId: value.workspaceId, status: 'online' };
    locks.value = Object.fromEntries(
      value.locks.map((item) => [item.resourceKey, { ...item, acquired: true }]),
    );
  }
  function clearWorkspaceState(): void {
    presence.value = {};
    locks.value = {};
  }
  return {
    connected,
    presence,
    locks,
    setConnected,
    updatePresence,
    updateLock,
    applySnapshot,
    clearWorkspaceState,
  };
});
